import React from 'react';
import styles from './Cycles.module.scss';
import useApiData from '../../../../../hooks/useApiData';
import Loading from '../../../Common/Loading/Loading';
import { getErrorComponentFromHttpError } from '../../../Common/Error/Error';
import ScoreDisplay from '../../../Common/ScoreDisplay/ScoreDisplay';
import Table from '../../../Common/Table/Table/Table';
import AddIcon from '@mui/icons-material/Add';
import useAuth from '../../../../../hooks/useAuth';

export default function Cycles() {
  const { groups } = useAuth();
  const { data, error, isLoading } = useApiData({
    path: '/administrator/cycles',
  });
  if (isLoading) {
    return <Loading message="Fetching cycles..." />;
  }

  if (error || data === null) {
    return getErrorComponentFromHttpError(error);
  }

  return (
    <Table
      rows={data}
      topButtons={
        groups.includes('administrators')
          ? [
              {
                label: 'Create Cycle',
                variant: 'contained',
                startIcon: <AddIcon />,
                to: '/administrator/organisation/cycles/create',
              },
            ]
          : undefined
      }
      linkFunction={(id) => id}
      rowLinks={{
        label: {
          label: 'View Cycle',
          to: (id) => id,
        },
      }}
      title="Cycles"
      columns={[
        {
          id: 'label',
          label: 'Label',
          numeric: false,
        },
        {
          id: 'isCurrent',
          label: 'Current',
          boolean: true,
        },
      ]}
    />
  );
}
